module.exports = __webpack_public_path__ + "img/atom.598bd393.svg";